import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { AppMedError } from '../../../error/AppMedError.ts';
import { EICFTemplatesApi } from '../../../apis/EICFApi/EICFTemplatesApi.ts';

export function useUnassignEICFTemplate() {
    const queryClient = useQueryClient();
    return useMutation<void, AppMedError, number>({
        mutationKey: [QueryKeys.eicfTemplates, 'unassign'],
        mutationFn: (facilityId) => EICFTemplatesApi.unassignFromFacility(facilityId),
        onSuccess: (_data, facilityId) => {
            queryClient.invalidateQueries({ queryKey: [QueryKeys.eicfFacilityActiveTemplate, facilityId] });
        },
    });
}
